var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.subtasks),function(subtask,index){return _c('SubtasksItem',{key:subtask.id,attrs:{"parent":_vm.task,"last":index === _vm.subtasks.length - 1,"subtask":subtask,"level":_vm.level,"leaf-levels":_vm.leafLevels}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }